/**
 * Impact Theme Custom Order JS (Zepto)
 * Loaded by sections/main-product.liquid for products tagged "Custom Order"
 * 1. Custom Order Image Zoom
 * 2. Zepto Field Order
 * 3. Custom Order Sticky Preview
 * 4. Zepto Swatch Scrollbar
 * 5. Custom Order Option Tracking
 * 6. Preview Caption
 * 7. Simulator Preview Save
 * 8. Cart Preview Caption
 */

// 1. Custom Order Image Zoom
(function () {
  if (window.__isCustomOrder !== true) return;
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  function bindZoom(target) {
    if (!target || target.dataset.zoomBound) return;
    target.dataset.zoomBound = 'true';

    var rect = null;
    var last = null;
    var active = false;
    var ticking = false;

    function layers() {
      return Array.prototype.filter.call(target.querySelectorAll('canvas, .co-caption'), function (element) {
        return element.parentNode === target;
      });
    }

    function apply(event) {
      var x = ((event.clientX - rect.left) / rect.width) * 100;
      var y = ((event.clientY - rect.top) / rect.height) * 100;
      layers().forEach(function (element) {
        element.dataset.coZoom = 'true';
        element.style.transformOrigin = x + '% ' + y + '%';
        element.style.transform = 'scale(2)';
      });
    }

    function reset() {
      target.querySelectorAll('[data-co-zoom]').forEach(function (element) {
        delete element.dataset.coZoom;
        element.style.transform = '';
        element.style.transformOrigin = '';
      });
      active = false;
      rect = null;
      last = null;
    }

    target.addEventListener('mouseenter', function (event) {
      rect = target.getBoundingClientRect();
      last = { x: event.clientX, y: event.clientY };
    });

    target.addEventListener('mousemove', function (event) {
      if (!rect) rect = target.getBoundingClientRect();
      if (!active) {
        if (!last || (last.x === event.clientX && last.y === event.clientY)) {
          last = { x: event.clientX, y: event.clientY };
          return;
        }
        active = true;
        apply(event);
        return;
      }
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        if (active && rect) apply(event);
        ticking = false;
      });
    });

    target.addEventListener('mouseleave', reset);
  }

  function bindAll() {
    var gallery = document.querySelector('.product-gallery');
    if (!gallery) return;
    gallery.querySelectorAll('.pplr_preview_wrapper').forEach(bindZoom);
    if (gallery.dataset.zoomGalleryObserved) return;
    gallery.dataset.zoomGalleryObserved = 'true';
    new MutationObserver(function () {
      gallery.querySelectorAll('.pplr_preview_wrapper').forEach(bindZoom);
    }).observe(gallery, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bindAll);
  else bindAll();
  document.addEventListener('shopify:section:load', bindAll);
  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;
    document.querySelectorAll('[data-zoom-bound]').forEach(function (el) { delete el.dataset.zoomBound; });
    bindAll();
  });
})();

// 2. Zepto Field Order
(function () {
  if (window.__isCustomOrder !== true) return;

  function moveCollar(container) {
    var collar = container.querySelector('.pplr-wrapper.pplr-collar');
    if (!collar) return false;
    container.insertBefore(collar, container.firstChild);
    collar.style.visibility = 'visible';
    return true;
  }

  function watchCollar(container) {
    if (moveCollar(container) || container.querySelector('.pplr-wrapper')) return;
    var collarObserver = new MutationObserver(function () {
      if (moveCollar(container) || container.querySelector('.pplr-wrapper')) collarObserver.disconnect();
    });
    collarObserver.observe(container, { childList: true, subtree: true });
  }

  var rootTarget = document.querySelector('[is="product-form"]');
  if (!rootTarget) return;

  function findContainer() {
    var container = rootTarget.querySelector('.product-personalizer');
    if (container) watchCollar(container);
    return !!container;
  }

  if (findContainer()) return;
  var rootObserver = new MutationObserver(function () {
    if (findContainer()) rootObserver.disconnect();
  });
  rootObserver.observe(rootTarget, { childList: true, subtree: true });
})();

// 3. Custom Order Sticky Preview
(function () {
  if (window.__isCustomOrder !== true) return;

  var product = document.querySelector('.product--custom-order');
  if (!product) return;
  var gallery = product.querySelector('.product-gallery');
  if (!gallery) return;
  var form = product.querySelector('form[is="product-form"]');

  var mqDesktop = window.matchMedia('(min-width: 1000px)');
  var ticking = false;
  var viewportW = 0;
  var viewportH = 0;

  function stableViewportHeight() {
    if (window.innerWidth !== viewportW) {
      viewportW = window.innerWidth;
      viewportH = window.innerHeight;
    }
    return viewportH;
  }

  function measure() {
    var arWrapper = gallery.querySelector('.product-gallery__ar-wrapper');
    if (!arWrapper) return false;
    var galleryHeight = gallery.offsetHeight;
    var mediaHeight = arWrapper.offsetHeight;
    var previewHeight = Math.round(stableViewportHeight() / 3);
    if (!galleryHeight || !mediaHeight) return false;
    var key = galleryHeight + '|' + mediaHeight + '|' + previewHeight;
    if (product.dataset.coMetrics === key) return true;
    product.dataset.coMetrics = key;
    product.style.setProperty('--co-gallery-height', galleryHeight + 'px');
    product.style.setProperty('--co-thumbs-height', (galleryHeight - mediaHeight) + 'px');
    product.style.setProperty('--co-preview-height', previewHeight + 'px');
    product.style.setProperty('--co-preview-scale', Math.min(previewHeight / mediaHeight, 1).toFixed(4));
    return true;
  }

  function update() {
    ticking = false;
    var isDesktop = mqDesktop.matches;
    if (!isDesktop && !measure()) return;

    var prevShift = parseFloat(gallery.dataset.coShift || '0');
    var rect = gallery.getBoundingClientRect();
    var stickyTop = parseFloat(getComputedStyle(gallery).top);
    var stuck = rect.top - prevShift <= stickyTop + 1;

    var shift = 0;
    if (stuck) {
      if (form) {
        var consent = form.querySelector('.consent-checkbox-wrapper');
        var buyButtons = form.querySelector('.buy-buttons');
        var save = product.querySelector('.zepto-save');
        var stopEdge = consent
          ? consent.getBoundingClientRect().bottom
          : buyButtons
            ? buyButtons.getBoundingClientRect().top
            : save
              ? save.getBoundingClientRect().bottom
              : form.getBoundingClientRect().bottom;
        shift = Math.min(0, stopEdge - (rect.bottom - prevShift));
      }
    }
    if (shift !== prevShift) {
      gallery.dataset.coShift = shift;
      gallery.style.transform = shift ? 'translateY(' + shift + 'px)' : '';
    }

    product.classList.toggle('is-gallery-condensed', stuck && !isDesktop);
  }

  function requestUpdate() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(update);
  }

  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate);
  requestUpdate();
})();

// 4. Zepto Swatch Scrollbar
(function () {
  if (window.__isCustomOrder !== true) return;

  var MQ = window.matchMedia('(max-width: 700px)');

  var debounce = function (fn, ms) {
    var t;
    return function () { clearTimeout(t); t = setTimeout(fn, ms); };
  };

  var allUpdaters = [];
  var runUpdaters = debounce(function () {
    allUpdaters.slice().forEach(function (fn) { fn(); });
  }, 150);
  window.addEventListener('resize', runUpdaters);
  if (MQ.addEventListener) MQ.addEventListener('change', runUpdaters);

  function setup(main) {
    if (main.dataset.customBar === 'ready') return;
    main.dataset.customBar = 'ready';

    var bar = document.createElement('div');
    bar.className = 'pplr-custom-bar';
    bar.setAttribute('aria-hidden', 'true');
    var thumb = document.createElement('div');
    thumb.className = 'pplr-custom-bar__thumb';
    bar.appendChild(thumb);
    main.insertAdjacentElement('afterend', bar);

    var metrics = null;
    var ticking = false;

    function position() {
      ticking = false;
      if (!metrics) return;
      thumb.style.transform = 'translateX(' + metrics.range * (main.scrollLeft / metrics.max) + 'px)';
    }

    var update = function () {
      if (!main.isConnected) {
        var i = allUpdaters.indexOf(update);
        if (i > -1) allUpdaters.splice(i, 1);
        bar.remove();
        return;
      }
      metrics = null;
      if (!MQ.matches) { bar.hidden = true; return; }

      var scrollWidth = main.scrollWidth;
      var clientWidth = main.clientWidth;
      var max = scrollWidth - clientWidth;
      if (max <= 0) { bar.hidden = true; return; }
      bar.hidden = false;

      var trackW = bar.clientWidth;
      var thumbW = Math.max(24, Math.round(trackW * (clientWidth / scrollWidth)));
      thumb.style.width = thumbW + 'px';
      metrics = { max: max, range: trackW - thumbW };
      position();
    };

    allUpdaters.push(update);
    main.addEventListener('scroll', function () {
      if (ticking || !metrics) return;
      ticking = true;
      requestAnimationFrame(position);
    }, { passive: true });

    var selected = main.querySelector('.selected');
    if (selected && MQ.matches) {
      var paddingLeft = parseFloat(getComputedStyle(main).paddingInlineStart) || 0;
      main.scrollLeft = selected.offsetLeft - paddingLeft;
    }
    update();
  }

  function init() {
    document.querySelectorAll('.pplr-swatch-main').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  var target = document.querySelector('.product-info') || document.querySelector('main');
  if (target) {
    new MutationObserver(debounce(init, 150)).observe(target, { childList: true, subtree: true });
  }
})();

// 5. Custom Order Option Tracking
(function () {
  if (window.__isCustomOrder !== true) return;

  function track(item) {
    var props = item && item.properties;
    if (!props) return;

    var deliveryLabelEl = document.getElementById('label-delivery-date');
    var deliveryLabel = deliveryLabelEl ? deliveryLabelEl.dataset.label || '' : '';

    var options = [];
    Object.keys(props).forEach(function (name) {
      var value = props[name];
      if (name.charAt(0) === '_') return;
      if (name === deliveryLabel) return;
      if (typeof value !== 'string' || value.length === 0) return;
      if (/^https?:\/\//i.test(value)) return;
      options.push({ name: name, value: value.slice(0, 100) });
    });
    if (!options.length) return;

    if (!window.Shopify || !window.Shopify.analytics || typeof window.Shopify.analytics.publish !== 'function') return;
    window.Shopify.analytics.publish('custom_order_add_to_cart', {
      productId: item.product_id || null,
      productTitle: item.product_title || item.title || '',
      variantId: item.variant_id || null,
      variantTitle: item.variant_title || '',
      quantity: item.quantity || 1,
      options: options
    });
  }

  document.addEventListener('variant:add', function (event) {
    var items = event.detail && event.detail.items;
    if (Array.isArray(items)) items.forEach(track);
  });
})();

// 6. Preview Caption
(function () {
  if (window.__isCustomOrder !== true) return;

  var product = document.querySelector('.product--custom-order');
  if (!product) return;
  var gallery = product.querySelector('.product-gallery');
  if (!gallery) return;

  var isSimulator = product.classList.contains('product--simulator');
  var CAPTION_LABELS = { project: 'Project', date: 'Date' };
  var sizeLabel = product.dataset.sizeLabel || '';
  var form = product.querySelector('form[is="product-form"]');
  var noteInput = product.querySelector('[data-simulator-note] input');
  var NOTE_KEY = 'rmfc:simulator-note';

  var caption = null;
  var canvas = null;
  var resizeObserver = null;
  var queued = false;
  var lastTop = null;
  var lastBottom = null;

  function pad(value) {
    return (value < 10 ? '0' : '') + value;
  }

  function today() {
    var now = new Date();
    return now.getFullYear() + '.' + pad(now.getMonth() + 1) + '.' + pad(now.getDate());
  }

  function readNote() {
    try {
      return localStorage.getItem(NOTE_KEY) || '';
    } catch (e) {
      return '';
    }
  }

  function writeNote(value) {
    try {
      if (value) localStorage.setItem(NOTE_KEY, value);
      else localStorage.removeItem(NOTE_KEY);
    } catch (e) {}
  }

  function note() {
    return noteInput ? noteInput.value.trim() : '';
  }

  function selectedVariantTitle() {
    var script = product.querySelector('variant-picker script[data-variant]');
    if (!script) return '';
    try {
      var variant = JSON.parse(script.textContent);
      return variant && variant.title ? variant.title : '';
    } catch (e) {
      return '';
    }
  }

  function topRows() {
    var rows = [];
    if (!isSimulator && sizeLabel) {
      var title = selectedVariantTitle();
      if (title) rows.push({ label: sizeLabel, value: title });
    }
    product.querySelectorAll('.product-personalizer .pplr-wrapper').forEach(function (wrapper) {
      if (wrapper.offsetParent === null) return;
      if (wrapper.classList.contains('cstmfy_static') || wrapper.classList.contains('pplr_no_preview')) return;
      var input = wrapper.querySelector('input[name^="properties["][data_name]');
      if (!input || !input.value || input.name.indexOf('properties[_') === 0) return;
      rows.push({ label: input.getAttribute('data_name'), value: input.value });
    });
    return rows;
  }

  function bottomRows() {
    if (!isSimulator) return [];
    var rows = [];
    var text = note();
    if (text) rows.push({ label: CAPTION_LABELS.project, value: text });
    rows.push({ label: CAPTION_LABELS.date, value: today() });
    return rows;
  }

  function escapeHtml(text) {
    return String(text).replace(/[&<>"]/g, function (char) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[char];
    });
  }

  function rowHtml(row) {
    return '<span class="co-caption__label">' + escapeHtml(row.label) + '</span><span class="co-caption__value">' + escapeHtml(row.value) + '</span>';
  }

  var MEASURE_UNIT = 10;
  var CJK = /[\u3000-\u30ff\u3400-\u4dbf\u4e00-\u9fff\uf900-\ufaff\uff00-\uffef]/;
  var measureCtx = document.createElement('canvas').getContext('2d');

  function tokenize(text) {
    var tokens = [];
    var word = '';
    Array.from(text).forEach(function (char) {
      if (char === ' ' || CJK.test(char)) {
        if (word) tokens.push(word);
        word = '';
        tokens.push(char);
      } else {
        word += char;
      }
    });
    if (word) tokens.push(word);
    return tokens;
  }

  function wrapText(ctx, text, maxWidth) {
    var lines = [];
    var line = '';
    tokenize(text).forEach(function (token) {
      if (!line && token === ' ') return;
      if (ctx.measureText(line + token).width <= maxWidth) {
        line += token;
        return;
      }
      if (line) lines.push(line.replace(/ +$/, ''));
      line = '';
      if (token === ' ') return;
      if (ctx.measureText(token).width <= maxWidth) {
        line = token;
        return;
      }
      Array.from(token).forEach(function (char) {
        if (line && ctx.measureText(line + char).width > maxWidth) {
          lines.push(line);
          line = '';
        }
        line += char;
      });
    });
    if (line || !lines.length) lines.push(line.replace(/ +$/, ''));
    return lines;
  }

  function captionMetrics(unit) {
    var style = getComputedStyle(caption);
    function metric(name) {
      return parseFloat(style.getPropertyValue(name)) || 0;
    }
    var fontSize = metric('--co-caption-font') * unit;
    return {
      fontSize: fontSize,
      line: metric('--co-caption-line') * unit,
      x: metric('--co-caption-margin') * unit,
      minLabelWidth: metric('--co-caption-label-width') * unit,
      gap: metric('--co-caption-gap') * unit,
      top: metric('--co-caption-top') * unit,
      bottom: metric('--co-caption-bottom') * unit,
      labelFont: metric('--co-caption-label-weight') + ' ' + fontSize + 'px ' + style.fontFamily,
      valueFont: metric('--co-caption-value-weight') + ' ' + fontSize + 'px ' + style.fontFamily,
      labelOpacity: metric('--co-caption-label-opacity') || 1,
      color: style.color || '#000'
    };
  }

  function layout(rows) {
    var m = captionMetrics(MEASURE_UNIT);
    measureCtx.font = m.labelFont;
    var labelWidth = rows.reduce(function (width, row) {
      return Math.max(width, measureCtx.measureText(row.label).width);
    }, m.minLabelWidth);
    var valueX = m.x + labelWidth + m.gap;
    var maxWidth = 100 * MEASURE_UNIT - valueX - m.x;
    var lines = [];
    measureCtx.font = m.valueFont;
    rows.forEach(function (row) {
      wrapText(measureCtx, row.value, maxWidth).forEach(function (text, index) {
        lines.push({ label: index === 0 ? row.label : '', value: text });
      });
    });
    return { valueX: valueX / MEASURE_UNIT, lines: lines };
  }

  function updateScale() {
    if (!canvas || !caption) return;
    var width = canvas.offsetWidth;
    if (!width) return;
    caption.style.left = canvas.offsetLeft + 'px';
    caption.style.top = canvas.offsetTop + 'px';
    caption.style.width = width + 'px';
    caption.style.height = canvas.offsetHeight + 'px';
    caption.style.setProperty('--co-scale', (width / 100) + 'px');
  }

  function ensureCaption() {
    var wrapper = gallery.querySelector('.pplr_preview_wrapper');
    if (!wrapper) return null;
    var current = wrapper.querySelector('#pplr_canvas');
    if (!current) return null;

    if (!caption || caption.parentNode !== wrapper) {
      caption = wrapper.querySelector('.co-caption');
      if (!caption) {
        caption = document.createElement('div');
        caption.className = 'co-caption';
        caption.setAttribute('aria-hidden', 'true');
        caption.innerHTML = '<div class="co-caption__rows co-caption__rows--top"></div><div class="co-caption__rows co-caption__rows--bottom"></div>';
        wrapper.appendChild(caption);
      }
      lastTop = null;
      lastBottom = null;
    }

    if (current !== canvas) {
      canvas = current;
      if (resizeObserver) resizeObserver.disconnect();
      resizeObserver = new ResizeObserver(updateScale);
      resizeObserver.observe(canvas);
      resizeObserver.observe(wrapper);
      updateScale();
    }
    return caption;
  }

  function render() {
    queued = false;
    var element = ensureCaption();
    if (!element) return;
    updateScale();
    var top = layout(topRows()).lines.map(rowHtml).join('');
    var bottom = layout(bottomRows()).lines.map(rowHtml).join('');
    if (top !== lastTop) {
      element.firstElementChild.innerHTML = top;
      lastTop = top;
    }
    if (bottom !== lastBottom) {
      element.lastElementChild.innerHTML = bottom;
      lastBottom = bottom;
    }
  }

  function requestRender() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(render);
  }

  function draw(ctx, width, height) {
    if (!ensureCaption()) return;
    var unit = width / 100;
    var m = captionMetrics(unit);

    ctx.textBaseline = 'top';
    ctx.textAlign = 'left';
    ctx.fillStyle = m.color;

    function drawLines(block, startY) {
      var valueX = block.valueX * unit;
      block.lines.forEach(function (line, index) {
        var y = startY + index * m.line;
        if (line.label) {
          ctx.font = m.labelFont;
          ctx.globalAlpha = m.labelOpacity;
          ctx.fillText(line.label, m.x, y);
          ctx.globalAlpha = 1;
        }
        ctx.font = m.valueFont;
        ctx.fillText(line.value, valueX, y);
      });
    }

    drawLines(layout(topRows()), m.top);
    var bottom = layout(bottomRows());
    drawLines(bottom, height - m.bottom - bottom.lines.length * m.line);
  }

  if (document.fonts && document.fonts.load) {
    document.fonts.load('600 16px RMFC').catch(function () {});
  }

  if (noteInput) {
    noteInput.value = readNote();
    noteInput.addEventListener('input', function () {
      writeNote(noteInput.value.trim());
      requestRender();
    });
    noteInput.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter') return;
      event.preventDefault();
      if (event.isComposing || event.keyCode === 229) return;
      noteInput.blur();
    });
  }

  new MutationObserver(requestRender).observe(gallery, { childList: true, subtree: true });

  var watchedPersonalizer = null;
  var personalizerObserver = null;

  function watchPersonalizer() {
    var personalizer = product.querySelector('.product-personalizer');
    if (personalizer === watchedPersonalizer) return;
    if (personalizerObserver) personalizerObserver.disconnect();
    personalizerObserver = null;
    watchedPersonalizer = personalizer;
    if (personalizer) {
      personalizerObserver = new MutationObserver(requestRender);
      personalizerObserver.observe(personalizer, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'value'] });
    }
    requestRender();
  }

  new MutationObserver(watchPersonalizer).observe(product, { childList: true, subtree: true });
  watchPersonalizer();
  if (form) form.addEventListener('variant:change', requestRender);
  requestRender();

  window.__rmfcCaption = { draw: draw, note: note };
})();

// 7. Simulator Preview Save
(function () {
  if (window.__isCustomOrder !== true) return;

  var wrapper = document.querySelector('[data-zepto-save]');
  if (!wrapper) return;

  var button = wrapper.querySelector('button');
  if (!button) return;

  var title = wrapper.dataset.zeptoSave || 'preview';

  function findCanvas() {
    var canvases = document.querySelectorAll('.pplr_preview_wrapper #pplr_canvas');
    for (var i = 0; i < canvases.length; i++) {
      if (canvases[i].width > 0 && canvases[i].offsetParent !== null) return canvases[i];
    }
    return null;
  }

  function hasCanvas() {
    var canvas = document.querySelector('.pplr_preview_wrapper #pplr_canvas');
    return !!(canvas && canvas.width > 0);
  }

  function reveal() {
    if (!hasCanvas()) return false;
    wrapper.hidden = false;
    return true;
  }

  if (!reveal()) {
    var scope = document.querySelector('.product-gallery') || document.body;
    var observer = new MutationObserver(function () {
      if (reveal()) observer.disconnect();
    });
    observer.observe(scope, { childList: true, subtree: true });
  }

  function pad(value) {
    return (value < 10 ? '0' : '') + value;
  }

  function cleanName(text) {
    return String(text).replace(/[\\/:*?"<>|]+/g, '').trim();
  }

  function fileName() {
    var now = new Date();
    var stamp = now.getFullYear() + pad(now.getMonth() + 1) + pad(now.getDate()) + '-' + pad(now.getHours()) + pad(now.getMinutes());
    var parts = [cleanName(title.split(' Custom ')[0]) || 'preview'];
    var note = window.__rmfcCaption ? cleanName(window.__rmfcCaption.note()) : '';
    if (note) parts.push(note);
    parts.push(stamp);
    return parts.join('_') + '.png';
  }

  function toBlob(canvas) {
    var binary = atob(canvas.toDataURL('image/png').split(',')[1]);
    var bytes = new Uint8Array(binary.length);
    for (var i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
    return new Blob([bytes], { type: 'image/png' });
  }

  function download(blob, name) {
    var url = URL.createObjectURL(blob);
    var link = document.createElement('a');
    link.href = url;
    link.download = name;
    document.body.appendChild(link);
    link.click();
    link.remove();
    setTimeout(function () { URL.revokeObjectURL(url); }, 1000);
  }

  function shareSupported() {
    return window.matchMedia('(pointer: coarse)').matches &&
      typeof navigator.share === 'function' &&
      typeof navigator.canShare === 'function';
  }

  function canShareFile(file) {
    return shareSupported() && navigator.canShare({ files: [file] });
  }

  button.addEventListener('click', function () {
    var canvas = findCanvas();
    if (!canvas) return;

    var name = fileName();
    var output = document.createElement('canvas');
    output.width = canvas.width;
    output.height = canvas.height;
    var ctx = output.getContext('2d');
    ctx.drawImage(canvas, 0, 0);
    if (window.__rmfcCaption) window.__rmfcCaption.draw(ctx, output.width, output.height);

    if (!shareSupported()) {
      try {
        output.toBlob(function (result) {
          if (!result) {
            console.error('Simulator Preview Save failed', 'toBlob returned null');
            return;
          }
          download(result, name);
        }, 'image/png');
      } catch (e) {
        console.error('Simulator Preview Save failed', e);
      }
      return;
    }

    var blob;
    try {
      blob = toBlob(output);
    } catch (e) {
      console.error('Simulator Preview Save failed', e);
      return;
    }

    var file = new File([blob], name, { type: 'image/png' });
    if (canShareFile(file)) {
      navigator.share({ files: [file], title: title }).catch(function (error) {
        if (!error || error.name !== 'AbortError') download(blob, name);
      });
      return;
    }
    download(blob, name);
  });
})();

// 8. Cart Preview Caption
(function () {
  if (window.__isCustomOrder !== true) return;

  var captioned = new WeakSet();
  var processing = new WeakSet();

  function captionFile(file) {
    return createImageBitmap(file).then(function (bitmap) {
      var canvas = document.createElement('canvas');
      canvas.width = bitmap.width;
      canvas.height = bitmap.height;
      var ctx = canvas.getContext('2d');
      ctx.drawImage(bitmap, 0, 0);
      if (bitmap.close) bitmap.close();
      window.__rmfcCaption.draw(ctx, canvas.width, canvas.height);
      return new Promise(function (resolve, reject) {
        canvas.toBlob(function (blob) {
          if (!blob) {
            reject(new Error('toBlob returned null'));
            return;
          }
          resolve(new File([blob], file.name, { type: blob.type }));
        }, file.type || 'image/png');
      });
    });
  }

  function replaceFile(input, file) {
    var transfer = new DataTransfer();
    transfer.items.add(file);
    input.files = transfer.files;
    captioned.add(file);
    captioned.add(input.files[0]);
  }

  function pendingInputs(form) {
    return Array.prototype.filter.call(form.elements, function (element) {
      return element.type === 'file' &&
        element.classList.contains('pplr_file_upload') &&
        element.files && element.files.length > 0 &&
        !captioned.has(element.files[0]);
    });
  }

  function resubmit(form, submitter) {
    if (submitter && submitter.form === form) form.requestSubmit(submitter);
    else form.requestSubmit();
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.matches('[is="product-form"]') || !window.__rmfcCaption) return;
    if (typeof form.requestSubmit !== 'function' || typeof createImageBitmap !== 'function') return;
    if (processing.has(form)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }
    var inputs = pendingInputs(form);
    if (!inputs.length) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    processing.add(form);
    var submitter = event.submitter;

    Promise.all(inputs.map(function (input) {
      return captionFile(input.files[0]).then(function (file) {
        replaceFile(input, file);
      }, function (error) {
        captioned.add(input.files[0]);
        console.error('Cart Preview Caption failed', error);
      });
    })).then(function () {
      processing.delete(form);
      resubmit(form, submitter);
    });
  }, { capture: true });
})();
